import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-text-range-input',
  templateUrl: './text-range-input.component.html',
  styleUrls: ['./text-range-input.component.css']
})
export class TextRangeInputComponent implements OnInit {
  comparator = '>=';
  @Output() valorDesdeChange = new EventEmitter();
  @Output() valorHastaChange = new EventEmitter();
  @Output() valorIgualChange = new EventEmitter();
  @Output() valorEntreChange = new EventEmitter();
  @Output() hasErrorFormControl = new EventEmitter();

  private _valorDesde: string;
  @Input()
  get valorDesde(): string {
    return this._valorDesde;
  }
  set valorDesde(desde: string) {
    const hasChangedValue = this.hasChangedValue(this._valorDesde, desde);
    this._valorDesde = desde;
    if (this.comparator == '<>' && this.mode === 'rangeSimple') {
        this.sendValorEntre();
        return;
    }
    if (hasChangedValue) {
      this.valorDesdeChange.emit(this._valorDesde);
    }

    if (this.mode === 'simpleRangeSearch') {
      this.valorHasta = this.valorDesde;
    }
  }

  private _valorHasta: string;
  @Input()
  get valorHasta(): string {
    return this._valorHasta;
  }
  set valorHasta(hasta: string) {
    const hasChangedValue = this.hasChangedValue(this._valorHasta, hasta);
    this._valorHasta = hasta;
    if (this.comparator == '<>' && this.mode === 'rangeSimple') {
      this.sendValorEntre();
      return;
    }
    if (hasChangedValue) {
      this.valorHastaChange.emit(this._valorHasta);
    }
  }

  private _igual: string;
  @Input()
  get valorIgual(): string {
    return this._igual;
  }
  set valorIgual(igual: string) {
    const hasChangedValue = this.hasChangedValue(this._igual, igual);
    this._igual = igual;
    if (hasChangedValue) {
      this.valorIgualChange.emit(this._igual);
    }
  }
  @Input() nombreCampo: string;
  @Input() mode: string;

  constructor() {}

  ngOnInit() {}

  resetValues() {
    this.valorDesde = undefined;
    this.valorHasta = undefined;
    this.valorIgual = undefined;
    this.hasErrorFormControl.next(false);
  }

  private sendValorEntre() {
    if (
      (this.valorDesde && !this.valorHasta) ||
      (!this.valorDesde && this.valorHasta)
    ) {
      this.hasErrorFormControl.next(true);
    } else {
      this.hasErrorFormControl.next(false);
    }
    const object = { desde: this._valorDesde, hasta: this._valorHasta };
    this.valorEntreChange.emit(object);
  }

  private hasChangedValue(value1: string, value2: string): boolean {
    if (!value1 && !value2) { return false; }
    return value1 !== value2;
   }
}
